import React from "react";
import "./Greeting.css";
// import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import BannerImg from "./BannerImg";
import Typewriter from "typewriter-effect";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import { competitiveSites } from "../../portfolio";
export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.orange }}>
                {greeting.title}
              </h1>
              <h1 className="greeting-sub" style={{ color: theme.grayText }}>
                I'm <mark data-entity="person">{greeting.sub}</mark>
              </h1>
              <h1 className="greeting-typewriter" style={{ color: theme.blue }}>
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString("DevOps Engineer👷")
                      .pauseFor(100)
                      .deleteAll()
                      .typeString("AWS/Azure/GCP Expert🌩️")
                      .pauseFor(100)
                      .deleteAll()
                      .typeString("Cloud CostOptimizer💰")
                      .pauseFor(100)
                      .deleteAll()
                      .typeString("SRE Engineer💻")
                      .pauseFor(100)
                      .start()
                      .deleteAll()
                      .typeString("CyberSecurity Enthusiast🔐")
                      .pauseFor(100)
                      .start();
                  }}
                  options={{
                    autoStart: true,
                    loop: true,
                  }}
                />
              </h1>
              <span
                className="greeting-text-span subTitle"
                style={{ color: theme.text }}
              >
                <div className="entities">
                  A <mark data-entity="9+ Exp">DevOps Engineer</mark> who
                  thrives to{" "}
                  <mark data-entity="all size">leverage Startups</mark> using
                  modern cloud technology following{" "}
                  <mark data-entity="top notch">DevOps Practice</mark> and a
                  blend of <mark data-entity="secure">Cyber Security</mark>
                  and help reduce <mark data-entity="optimize">Cloud Cost</mark>
                </div>
              </span>
              <CompetitiveSites logos={competitiveSites.competitiveSites} />
              <div className="button-greeting-div">
                <Button text="Contact me" href="/contact" />
                <Button
                  text="See my resume"
                  newTab={true}
                  href="https://drive.google.com/file/d/1XB8IceoyUVoNXtgEKRCOSXDRROKLt84S/view"
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <BannerImg />
          </div>
        </div>
      </div>
    </Fade>
  );
}
